import createFirehoseApi from './client';

export default options => ({
    firehose: createFirehoseApi(options),
});
